import { Component } from '@angular/core';

@Component({
    selector: 'kws-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'client';
}
